import { useTranslation } from "react-i18next";
import LeafButton, { Variant } from "../../leaf/LeafButton/LeafButton";
import { LeafModal } from "../../leaf/LeafModal/LeafModal";
import defaultContent from "../../../content/hat";
import "./TermsAndConditions.scss";

export const TermsAndConditions = ({
  open,
  dismissCallbackFn,
  agreeCallbackFn,
}: {
  open: boolean;
  dismissCallbackFn: Function;
  agreeCallbackFn: Function;
}) => {
  const { t } = useTranslation(["hat"]);

  return (
    <div className="TermsAndConditions">
      <LeafModal open={open} onCloseCallbackFn={dismissCallbackFn} id="Terms-And-Conditions-Modal">
        <h6 className="TermsAndConditions__title">
          {t("termsAndConditions.title", defaultContent.termsAndConditions.title as string)}
        </h6>
        <p className="TermsAndConditions__disclaimer">
          {t("termsAndConditions.disclaimer", defaultContent.termsAndConditions.disclaimer as string)}
        </p>

        <div className="TermsAndConditions__callToActionButtons">
          <LeafButton clickAction={dismissCallbackFn} id="Terms-Dismiss-Button">
            {t("termsAndConditions.dismissBtn", defaultContent.termsAndConditions.dismissBtn as string)}
          </LeafButton>
          <LeafButton clickAction={agreeCallbackFn} id="Terms-Agree-Button" variant={Variant.SOLID}>
            {t("termsAndConditions.agreeBtn", defaultContent.termsAndConditions.agreeBtn as string)}
          </LeafButton>
        </div>
      </LeafModal>
    </div>
  );
};
